import ApiRequest, { IResponseResult } from '@/common/request';

export interface IRechargeRecord {
  orderNo: string; // 订单号
  cardNo: string; // 卡号
  sellName: string; // 订单商品名称
  payAmount: string; // 支付金额
  payType: string; // 支付方式 1=微信, 2=平台充值, 4=支付宝
  payTime: string; // 支付成功时间
  rechargeStatus: number; // 充值展示状态 1=充值完成, 2=退款成功, 3=充值处理中, 4=待完成支付
}

/**
 * 查询充值记录
 */
export const getRechargeRecords = async (params: { cardNo: string }): Promise<IResponseResult<IRechargeRecord[]>> => {
  return ApiRequest.get(`/v2/query/rechargeRecords?`, params);
};
